export const baseUrl = "https://f.youdao.com"
// export const baseUrl = "https://at-test1.youdao.com"

// export const baseUrl =
//   process.env.buildMode === "prod"
//     ? "https://f.youdao.com"
//     : "https://at-test1.youdao.com";
